import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FieldSection } from '../../../formSection/fieldSection/FieldSection'
import { AddNewProgramFormModel } from '../../../AddNewProgram.types'

import { Checkbox } from '@percent/lemonade'

export function Eligibility() {
  const { t } = useTranslation()

  const { setValue, control } = useFormContext<AddNewProgramFormModel>()

  const [isEligibility] = useWatch({
    control,
    name: ['isEligibility']
  })

  return (
    <FieldSection subSection>
      <Checkbox
        variant="default"
        active={!!isEligibility}
        name="eligibility"
        label={t('form.eligibility')}
        onChange={() => setValue('isEligibility', !isEligibility)}
      />
    </FieldSection>
  )
}
